module.exports = __webpack_public_path__ + "static/media/Lotto12.00169cee.png";